import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { context } from '../../../globalState/GlobalState';
import Spinner1 from '../../uiElements/spinners/spinner1/Spinner1';
import BreadCrumbs1 from '../../uiElements/breadCrumbs/breadCrumbs1/BreadCrumbs1';
import ArticleComponent1 from '../../uiElements/articleComponents/articleComponent1/ArticleComponent1';

const Article1 = (props) => {
    const { id, title, author, featureImage, content, mobileContent, timeOfArticle, published, photos, galleryId, galleryPublished, game, gameId, opponentName, opponentLogo, gameStatus, homeGame, timeOfGame, loadingSpinner, secondaryLoadingSpinner, galleryLoadingSpinner, gameLoadingSpinner } = props;
    const { globalState } = useContext(context);

    const getBreadCrumbsLinks = () => {
        return [
            {
                title: 'Home',
                link: '/',
            },
            {
                title: 'Articles',
                link: '/articles',
            },
        ];
    };

    return (
        <>
            {loadingSpinner ? <Spinner1 color={globalState.websiteStyles.colors.primaryColor} /> : (
                <>
                    <BreadCrumbs1 links={getBreadCrumbsLinks()} lastCrumb={title} marginLeft="100px" />
                    <ArticleComponent1
                        id={id}
                        title={title}
                        author={author}
                        featureImage={featureImage}
                        content={content}
                        mobileContent={mobileContent}
                        timeOfArticle={timeOfArticle}
                        galleryId={galleryId}
                        photos={photos}
                        galleryPublished={galleryPublished}
                        game={game}
                        gameId={gameId}
                        opponentName={opponentName}
                        opponentLogo={opponentLogo}
                        gameStatus={gameStatus}
                        homeGame={homeGame}
                        timeOfGame={timeOfGame}
                        deleted={false}
                        published={published}
                        loadingSpinner={secondaryLoadingSpinner}
                        galleryLoadingSpinner={galleryLoadingSpinner}
                        gameLoadingSpinner={gameLoadingSpinner}
                    />
                </>
            )}
        </>
    );
};

Article1.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
    featureImage: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    mobileContent: PropTypes.string.isRequired,
    timeOfArticle: PropTypes.object.isRequired,
    published: PropTypes.bool.isRequired,
    photos: PropTypes.array.isRequired,
    galleryId: PropTypes.string.isRequired,
    galleryPublished: PropTypes.bool.isRequired,
    game: PropTypes.object.isRequired,
    gameId: PropTypes.string.isRequired,
    opponentName: PropTypes.string.isRequired,
    opponentLogo: PropTypes.string.isRequired,
    gameStatus: PropTypes.string.isRequired,
    homeGame: PropTypes.bool.isRequired,
    timeOfGame: PropTypes.object.isRequired,
    loadingSpinner: PropTypes.bool.isRequired,
    secondaryLoadingSpinner: PropTypes.bool.isRequired,
    galleryLoadingSpinner: PropTypes.bool.isRequired,
    gameLoadingSpinner: PropTypes.bool.isRequired,
};

export default memo(Article1);
